'use client';

import * as DS from '@aurorasolar/ds';

type IndicatorProps = { centered?: boolean };

export const TrustIndicators = ({ centered }: IndicatorProps) => {
  return (
    <DS.Flex
      color="uiHelperCopy"
      flexDirection="row"
      gap={4}
      justifyContent={centered ? 'center' : 'flex-start'}
      text={{ _: 'body12', xl: 'body16' }}
    >
      <DS.Flex alignItems="center" flexDirection="row" gap={1} w="auto">
        <DS.IconCheckCircle size={{ _: 4, xl: 5 }} />
        100% Free
      </DS.Flex>
      <DS.Flex alignItems="center" flexDirection="row" gap={1} w="auto">
        <DS.IconLockClosed size={{ _: 4, xl: 5 }} />
        Secure
      </DS.Flex>
      <DS.Flex alignItems="center" flexDirection="row" gap={1} w="auto">
        <DS.IconDiscount size={{ _: 4, xl: 5 }} />
        Low price comparison
      </DS.Flex>
    </DS.Flex>
  );
};
